module.exports = __webpack_public_path__ + "img/3.b28a98b9.jpg";